var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {ResetDeviceAsync as InvokeAsync , ResetDeviceSync as InvokeSync}

async function ResetDeviceAsync(LoginToken,DeviceUUID)
{
    var ResetDevicePromise = new Promise((resolve, reject) => {
        ResetDeviceSync(LoginToken,DeviceUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await ResetDevicePromise;
}

function ResetDeviceSync(LoginToken,DeviceUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/ResetDevice',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            DeviceUUID:DeviceUUID ,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
